module.exports = __webpack_public_path__ + "img/W-32.8ea02b94.jpg";